(ns common.widgets.details
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Typography$default" :as Typography]))

(defn details [summary & details]
  [:details
   [:> Typography {:component "summary"
                   :font-weight 500
                   :sx {:cursor "pointer"
                        :text-decoration "underline"}}  summary]
   (into [:> Box {:mt 1
                  :p 1
                  :sx {:border-style "solid"
                       :border-width 1
                       :border-color "grey.60"}}] details)])
